export const ExclusiveEmptyCard = () => {
  return (
    <div className="overflow-hidden relative aspect-video rounded shadow-[inset_0_0_0_1px_rgba(255,255,255,0.05)] flex flex-col items-center justify-center">
      <div className="relative z-10 flex flex-col items-center justify-center gap-2 max-w-56 text-center">
        <h2>No Exclusives Unlocked</h2>
        <p className="text-sm text-gray-11">
          Unlock items to access Exclusives like content, music, sweepstakes, and more.
        </p>
      </div>
    </div>
  )
}
